export default __webpack_public_path__ + "static/object-tile-anatomy-light-43d89f450a8242f61cad8c6555d53070.png";